/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "./Students.css";

// api
import studentApi from "../../api/Student";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import StudentsTable from "../../components/tables/primeTable/students/StudentsTable";
import TableLoading from "../../components/skeleton/TableLoading";

const Classmates = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [studentData, setStudentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    // fetch student
    try {
      getStudents();
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load student. Please try again later."
      );
      if (!empty(location) && !empty(location.state)) {
        navigate(null, {
          replace: true,
          state: { studentAdded: false, studentUpdated: false },
        });
      }
    }
  }, [first, rows, search]);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // function to get all student
  const getStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const classId =
        !empty(user) && !empty(user.currentClassId) ? user.currentClassId : "";
      const page = first / rows;
      let response;
      response = await studentApi.getStudentsInClass(
        page,
        rows,
        search,
        classId,
        "list"
      );

      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStudentData([]);
      } else {
        setStudentData(response_data.response);
        setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const onSearchChange = (event) => {
    setSearchValue(event.target.value);
    setFirst(0);
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      setSearch(event.target.value);
      setFirst(0);
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader title="Classmates" />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <StudentsTable
                students={studentData}
                onPageChange={onPageChange}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={searchValue}
                onSearchChange={onSearchChange}
                onKeyDown={onKeyDown}
              />
            ) : (
              <TableLoading />
            )}
            {/* table end  */}
          </div>
        </main>
      </AppWrapper>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default Classmates;
